<!--
 * @Description  : 商品列表
 * @Author       : git config user.sname
 * @Date         : 2025-12-15 13:38:30
 * @LastEditors  : panyangyang
 * @LastEditTime : 2026-02-25 09:13:13
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\commodity-management\product-list\index.vue
-->
<template>
	<div class="h100 operation-layout product-list">
		<filter-layout @search="doSearch" @reset="resetSerach" hasMore :hasHeader="false">
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" label-width="100px" :model="searchForm">
					<el-form-item label="商品名称：">
						<el-input :placeholder="'请输入'" size="small" v-model="searchForm.sname" clearable> </el-input>
					</el-form-item>
					<el-form-item label="商品识别码：">
						<el-input :placeholder="'请输入'" size="small" v-model="searchForm.proId" clearable> </el-input>
					</el-form-item>
					<el-form-item label="商品归类：">
						<el-cascader
							v-model="searchForm.proAttr"
							separator=" > "
							:options="proAttrOptions"
							:props="{ expandTrigger: 'hover', label: 'sname' }"
							clearable
						></el-cascader>
					</el-form-item>
					<el-form-item label="归属主体：">
						<el-select v-model="searchForm.applySub" size="small" clearable>
							<el-option v-for="item in gszt" :key="item.value" :label="item.sname" :value="item.value"> </el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" label-width="100px" :model="searchForm">
					<el-form-item label="创建人：">
						<el-input :placeholder="'请输入'" size="small" v-model="searchForm.createUser" clearable> </el-input>
					</el-form-item>
					<el-form-item label="创建时间：">
						<el-date-picker
							v-model="searchForm.dateArr"
							type="daterange"
							clearable
							placeholder="请选择"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="商品状态：">
						<el-select v-model="searchForm.status" size="small" clearable>
							<el-option v-for="item in proStatus" :key="item.value" :label="item.sname" :value="item.value"> </el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							商品合计：<span class="blue">{{ tableObj.total }}</span> 个
						</div>
						<div class="btnGroups">
							<el-button type="primary" size="mini" plain @click="doExport">导出</el-button>
							<el-button type="primary" class="btn-blue" size="mini" @click="handleClick('add', '')">
								新增商品
							</el-button>
							<el-button type="primary" class="ml5 btn-blue" size="mini" @click="resetSerach">
								<i class="el-icon-refresh"></i>
							</el-button>
						</div>
					</div>
				</div>
				<div class="operation-container w-table-layout w-table-page">
					<div class="w-table-content">
						<vxe-table
							ref="xTable"
							:data="tableObj.tableData"
							highlight-current-row
							highlight-hover-row
							align="left"
							border
							height="100%"
							size="small"
							auto-resize
							resizable
							show-header-overflow="tooltip"
						>
							<vxe-table-column type="seq" title="序号" width="55px" align="center"></vxe-table-column>
							<vxe-table-column field="sname" title="商品名称" min-width="150px" show-overflow="tooltip"></vxe-table-column>
							<vxe-table-column
								field="proId"
								title="商品识别码"
								min-width="150px"
								align="center"
								show-overflow="tooltip"
							></vxe-table-column>
							<vxe-table-column
								field="proTypeName"
								title="商品类型"
								min-width="150px"
								align="center"
								show-overflow="tooltip"
							></vxe-table-column>
							<vxe-table-column
								field="proSupName"
								title="商品大类"
								min-width="150px"
								align="center"
								show-overflow="tooltip"
							></vxe-table-column>
							<vxe-table-column
								field="proSubName"
								title="商品子类"
								min-width="150px"
								align="center"
								show-overflow="tooltip"
							></vxe-table-column>
							<vxe-table-column
								field="applySubName"
								title="归属主体"
								min-width="100px"
								align="center"
								show-overflow="tooltip"
							></vxe-table-column>
							<vxe-table-column field="feeType" title="收费方式" min-width="100px" align="center" show-overflow="tooltip">
								<template v-slot="{ row }">
									<span>{{ row.feeType == '0' ? '周期收费' : row.feeType == '1' ? '按次收费' : '' }}</span>
								</template>
							</vxe-table-column>
							<vxe-table-column field="cycleType" title="收费规则" min-width="100px" align="center" show-overflow="tooltip">
								<template v-slot="{ row }">
									<span v-if="row.feeType == '0'">{{
										row.cycleType == '0' ? '按年收费' : row.cycleType == '1' ? '按月收费' : row.cycleType == '2' ? '按天收费' : ''
									}}</span>
									<span v-if="row.feeType == '1'">{{
										row.cycleType == '0' ? '固定单价' : row.cycleType == '1' ? '阶梯单价' : ''
									}}</span>
								</template>
							</vxe-table-column>
							<vxe-table-column field="goodPrice" title="商品价格" min-width="280px" align="center">
								<template v-slot="{ row }">
									<span v-for="(item, index) in row.pricArr" :key="'价格' + index">
										<span>{{ item }}</span
										><br />
									</span>
								</template>
							</vxe-table-column>
							<vxe-table-column field="status" title="商品状态" min-width="100px" align="center" show-overflow="tooltip">
								<template v-slot="{ row }">
									<span>{{
										row.status == '0'
											? '下架'
											: row.status == '1'
											? '上架'
											: row.status == '2'
											? '已售罄'
											: row.status == '3'
											? '暂停销售'
											: ''
									}}</span>
								</template>
							</vxe-table-column>
							<vxe-table-column
								field="createUser"
								title="创建人"
								min-width="100px"
								align="center"
								show-overflow="tooltip"
							></vxe-table-column>
							<vxe-table-column
								field="createDate"
								title="创建时间"
								min-width="150px"
								align="center"
								show-overflow="tooltip"
							></vxe-table-column>
							<vxe-table-column title="操作" min-width="260px" align="center">
								<template v-slot="{ row }">
									<el-button
										class="table-btn"
										type="primary"
										round
										plain
										size="small"
										icon="el-icon-view"
										@click="handleClick('view', row)"
									>
										查看
									</el-button>
									<el-button
										class="table-btn"
										type="success"
										round
										plain
										size="small"
										v-if="roleBtns.includes('edit')"
										@click="handleClick('edit', row)"
									>
										<svg-icon icon-class="form-edit"></svg-icon> 编辑
									</el-button>
									<el-button
										type="danger"
										size="small"
										round
										plain
										class="table-btn"
										icon="el-icon-delete"
										v-if="roleBtns.includes('delete')"
										@click="handleClick('del', row)"
										:disabled="row.status != '0'"
										>删除</el-button
									>
								</template>
							</vxe-table-column>
						</vxe-table>
					</div>
					<div class="w-table-footer">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="tableObj.currentPage"
							:page-size="tableObj.pageSize"
							:page-sizes="[10, 20, 50, 100]"
							layout="total, sizes, prev, pager, next, jumper"
							:total="tableObj.total"
						>
						</el-pagination>
					</div>
				</div>
			</template>
		</filter-layout>
		<detailDialog ref="detailDialog" @updated="doSearch"></detailDialog>
	</div>
</template>
<script>
import { exportPlus } from 'utils/tools'
import { mapState } from 'vuex'
import XEUtils from 'xe-utils'

import * as Api from '@/api/modules/commodity-management'

import detailDialog from './components/detail-diaolg.vue'

export default {
	components: {
		detailDialog
	},
	data() {
		return {
			searchForm: {
				sname: '', //商品名称
				proId: '', //商品ID
				createUser: '', //创建人
				status: '', //状态
				applySub: '', //归属主体
				dateArr: '',
				proAttr: ''
			},
			tableObj: {
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				loading: false
			},
			proAttrOptions: [] //商品归类options
		}
	},
	created() {
		//商品类型码表
		this.getGoodCatCascade()
		//分页
		this.doSearch()
	},
	methods: {
		//查询
		doSearch() {
			this.getList()
		},
		//重置\刷新
		resetSerach() {
			this.searchForm = {
				sname: '', //商品名称
				proId: '', //商品ID
				createUser: '', //创建人
				status: '', //状态
				applySub: '', //归属主体
				dateArr: '',
				proAttr: ''
			}
			// this.searchForm.dateArr = ''
			// this.searchForm.proAttr = []
			this.tableObj.currentPage = 1
			this.tableObj.pageSize = 10
			this.getList()
		},
		// 表格 每页条数切换
		handleSizeChange(size) {
			this.tableObj.pageSize = size
			this.doSearch()
		},

		// 表格 页码切换
		handleCurrentChange(cur) {
			this.tableObj.currentPage = cur
			this.doSearch()
		},
		//分页数据
		getList() {
			this.tableObj.loading = true
			let params = XEUtils.clone(this.searchForm, true)
			params.createStartDate = this.searchForm.dateArr ? this.searchForm.dateArr[0] : ''
			params.createEndDate = this.searchForm.dateArr ? this.searchForm.dateArr[1] : ''
			params.proCat = this.searchForm.proAttr ? this.searchForm.proAttr.slice(-1)[0] : ''
			params.current = this.tableObj.currentPage
			params.size = this.tableObj.pageSize
			delete params.dateArr
			delete params.proAttr

			Api.getGoodPage(params)
				.then((res) => {
					this.tableObj.loading = false
					this.tableObj.tableData = res.data.records
					this.tableObj.total = parseInt(res.data.total)
					this.tableObj.tableData.map((item) => {
						item.pricArr = item.goodPrice.split('\n')
					})
				})
				.catch((err) => {
					this.tableObj.loading = false
					this.tableObj.tableData = []
				})
		},
		//按钮操作
		handleClick(type, obj) {
			switch (type) {
				case 'add':
				case 'edit':
				case 'view':
					this.$refs.detailDialog.openDialog(type, obj)
					break
				case 'del':
					if (obj.status != '0') {
						this.$message.warning('当前商品处于上架中，若需删除商品，请先下架该商品')
						return
					}
					let tips =
						obj.isconfedGive == '0'
							? '是否确认删除该商品？'
							: '当前商品已挂靠组合商品【' + obj.isconfedGiveMainGoodName + '   】,是否确认删除?'
					this.$confirm(tips, '删除提醒', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
						.then(() => {
							Api.delGood({ id: obj.id })
								.then((res) => {
									this.$message.success('删除成功!')
									this.doSearch()
								})
								.catch((err) => {})
						})
						.catch(() => {})
					break
			}
		},
		//获取商品属性
		getGoodCatCascade(vale, type) {
			Api.getGoodCatCascade({})
				.then((res) => {
					this.proAttrOptions = res.data
				})
				.catch((err) => {})
		},
		//导出
		doExport() {
			let search = XEUtils.clone(this.searchForm, true)
			const params = {
				...search
			}
			params.createStartDate = this.searchForm.dateArr ? this.searchForm.dateArr[0] : ''
			params.createEndDate = this.searchForm.dateArr ? this.searchForm.dateArr[1] : ''
			params.proCat = this.searchForm.proAttr ? this.searchForm.proAttr.slice(-1)[0] : ''

			delete params.dateArr
			delete params.proAttr
			exportPlus('/bmPayment/exportGoodExcel', params)
		}
	},
	computed: {
		...mapState('dict', {
			commodityDict: (state) => state.commodityDict //商品字典
		}),

		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),
		//商品状态
		proStatus() {
			let arr = [
				{
					value: '0',
					sname: '下架'
				},
				{
					value: '1',
					sname: '上架'
				},
				{
					value: '2',
					sname: '已售罄'
				},
				{
					value: '3',
					sname: '暂停销售'
				}
			]
			return arr
		},
		//归属主题
		gszt() {
			let arr = [
				{
					sname: '能工社',
					value: '1015003'
				},
				{
					sname: '安招采',
					value: '1015001'
				}
			]
			return arr
		}
	}
}
</script>
<style lang="less" scoped>
.product-list {
	/deep/.vxe-table--render-default .vxe-body--column.col--ellipsis {
		height: 60px;
	}
}
</style>
